/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
export enum ControlZonePermissions {
  CanViewCarts = 1,
  CanViewAnytimeWitness = 2,
  CanViewLocations = 4,
  CanViewStatistics = 8,
  CanViewCallToAction = 16
}